import React from "react";
import { classNames } from "../../../helpers/classNames";
import { ListboxOption } from "@headlessui/react";
import Scrollbars from "react-custom-scrollbars-2";

const RengeDropdown = ({ timeDropdownData, selectedValue, format }) => {
  const section = [
    { label: "Start Time", value: "startTime" },
    { label: "End Time", value: "endTime" },
  ];
  return (
    <div className="w-full flex divide-x">
      {section.map((item, index) => (
        <div
          key={index}
          className={classNames(
            "w-full text-sm text-center font-medium text-shades-05",
            index === 0 ? "pr-2" : "pl-2 border-dashed"
          )}
        >
          <div className="bg-chestnut-rose/10 p-2 rounded-md">
            {item?.label}
            <div className="flex w-full">
              {Object.entries(timeDropdownData).map(([key, values], i) => (
                <Scrollbars
                  autoHide
                  key={key}
                  style={{ width: 66, height: 200 }}
                  className={classNames(
                    "my-1",
                    i + 1 !== Object.keys(timeDropdownData).length &&
                      "border-r border-opplio-border/50"
                  )}
                >
                  {values.map((unit) => (
                    <ListboxOption
                      key={`${key}-${unit}`}
                      value={{
                        [item?.value]: { [key]: unit },
                      }}
                    >
                      {({ selected }) => (
                        <div
                          className={classNames(
                            "block truncate rounded px-2 py-1 hover:bg-[#0000000a] text-center text-sm text-[#000000e0] font-normal cursor-pointer",
                            (key === "hours" &&
                              selectedValue[item?.value][key] === unit) ||
                              (key === "minutes" &&
                                selectedValue[item?.value][key] === unit) ||
                              (key === "seconds" &&
                                selectedValue[item?.value][key] === unit) ||
                              (format === 12 &&
                                selectedValue[item?.value][key] === unit)
                              ? "!bg-chestnut-rose/70 !text-white"
                              : ""
                          )}
                        >
                          {unit}
                        </div>
                      )}
                    </ListboxOption>
                  ))}
                </Scrollbars>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RengeDropdown;
